import {
  BaseField,
  Button,
  Dialog,
  DialogContent,
  DialogTrigger,
  toast,
} from "@bleu.builders/ui";
import { useMachine } from "@xstate/react";
import { UserIcon } from "lucide-react";
import React from "react";
import { useForm } from "react-hook-form";

import { useOrganization } from "#/contexts/OrganizationContext";
import { diagnosisCreationStateMachine } from "#/lib/states/external_diagnosis";

import { CreationError, CreationInProgress, SuccessCreation } from "./shared";

const FIELDS = [
  {
    type: "input",
    name: "title",
    label: "Informe um nome para identificação do cliente analisado:",
    required: true,
  },
  {
    type: "hidden",
    name: "is_external",
    value: true,
  },
] as BaseField[];

export function CreateSingleExternalDiagnosisForm({
  title,
  description,
  path,
  fields,
}: {
  title: string;
  description: string;
  path: string;
  fields: BaseField[];
}) {
  const form = useForm();
  const [state, send] = useMachine(diagnosisCreationStateMachine);
  const organization = useOrganization();

  const handleSubmit = () => async () => {
    const isValid = await form.trigger();
    if (!isValid) {
      toast({
        title: "Erro",
        description: "Por favor, preencha todos os campos obrigatórios.",
        variant: "destructive",
      });
      return;
    }

    const data = form.getValues();
    send({
      type: "SUBMIT_DIAGNOSIS_DATA",
      diagnosisData: data,
      organizationId: organization?.id,
    });
  };

  switch (state.value) {
    case "fillingDiagnosisData":
    case "creationInProgress":
      return (
        <CreationInProgress
          title={title}
          description={description}
          path={path}
          fields={fields}
          form={form}
          state={state}
          handleSubmit={handleSubmit}
        />
      );
    case "diagnosisCreated":
      return (
        <SuccessCreation state={state} resourceTitle={form.getValues().title} />
      );
    case "diagnosisCreationError":
      return (
        <CreationError
          title="Erro ao criar diagnóstico externo"
          description="Ocorreu um erro ao criar diagnóstico externo."
          creationError={state.context.creationError}
        />
      );
    default:
      return null;
  }
}

export const SingleDiagnosisLinkCreation = () => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" className="w-full justify-start">
          <UserIcon className="mr-2 size-4" />
          Gerar link para um único diagnóstico
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[550px]">
        <CreateSingleExternalDiagnosisForm
          title="Diagnóstico externo"
          description="Gere e compartilhe o link para que o cliente responda ao formulário de diagnóstico tributário."
          path={"/"}
          fields={FIELDS}
        />
      </DialogContent>
    </Dialog>
  );
};
